import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=8f82899c&scoped=true"
import script from "./sort.vue?vue&type=script&lang=js"
export * from "./sort.vue?vue&type=script&lang=js"
import style0 from "./sort.vue?vue&type=style&index=0&id=8f82899c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f82899c",
  null
  
)

export default component.exports